// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeftSideBar_LeftSideBar__H581q {
  width: 200px;
  margin: 20px 0 0;
  overflow: hidden;
}
.LeftSideBar_LeftSideBar__H581q .LeftSideBar_List__B0KFu {
  list-style-type: none;
  border: 1px solid #aeaeae;
  border-radius: 5px;
}
.LeftSideBar_LeftSideBar__H581q .LeftSideBar_List__B0KFu .LeftSideBar_ListItem__OKfNj {
  border-bottom: 1px solid #aeaeae;
}
.LeftSideBar_LeftSideBar__H581q .LeftSideBar_List__B0KFu .LeftSideBar_ListItem__OKfNj.LeftSideBar_Active__gePWk {
  background: #228be6;
}
.LeftSideBar_LeftSideBar__H581q .LeftSideBar_List__B0KFu .LeftSideBar_ListItem__OKfNj.LeftSideBar_Active__gePWk .LeftSideBar_Link__fhZNt {
  color: #fff;
}
.LeftSideBar_LeftSideBar__H581q .LeftSideBar_List__B0KFu .LeftSideBar_ListItem__OKfNj:last-child {
  border: none;
}
.LeftSideBar_LeftSideBar__H581q .LeftSideBar_List__B0KFu .LeftSideBar_ListItem__OKfNj .LeftSideBar_Link__fhZNt {
  display: inline-block;
  padding: 5px 10px;
  text-decoration: none;
  width: 100%;
  color: #000000;
}`, "",{"version":3,"sources":["webpack://./src/components/LeftSideBar/LeftSideBar.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;EAEA,gBAAA;AAAJ;AAEI;EACI,qBAAA;EACA,yBAAA;EACA,kBAAA;AAAR;AAEQ;EACI,gCAAA;AAAZ;AAEY;EACI,mBAAA;AAAhB;AAEgB;EACI,WAAA;AAApB;AAIY;EACI,YAAA;AAFhB;AAKY;EACI,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAHhB","sourcesContent":[".LeftSideBar {\n    width: 200px;\n    margin: 20px 0 0;\n\n    overflow: hidden;\n\n    .List {\n        list-style-type: none;\n        border: 1px solid #aeaeae;\n        border-radius: 5px;\n\n        .ListItem {\n            border-bottom: 1px solid #aeaeae;\n\n            &.Active {\n                background: #228be6;\n\n                .Link {\n                    color: #fff;\n                }\n            }\n\n            &:last-child {\n                border: none;\n            }\n\n            .Link {\n                display: inline-block;\n                padding: 5px 10px;\n                text-decoration: none;\n                width: 100%;\n                color: #000000;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LeftSideBar": `LeftSideBar_LeftSideBar__H581q`,
	"List": `LeftSideBar_List__B0KFu`,
	"ListItem": `LeftSideBar_ListItem__OKfNj`,
	"Active": `LeftSideBar_Active__gePWk`,
	"Link": `LeftSideBar_Link__fhZNt`
};
export default ___CSS_LOADER_EXPORT___;
